import * as getCultures from "@/api/cultures/get";

export default {
	namespaced: true,
	state: {
		cultures: [],
		error: null,
	},
	getters: {
		readCultures: (state) => state.cultures,
		readError: (state) => {
			return state.error;
		},
	},
	mutations: {
		SET_CULTURES(state, payload) {
			state.cultures = payload;
		},
		SET_ERROR(state, payload) {
			state.error = payload;
		},
	},
	actions: {
		async getCultures({ commit, rootGetters }) {
			let token = rootGetters['loginStore/readToken']
			let getCulturesRes = await getCultures
				.getCultures(token)
				.then((data) => {
					commit("SET_CULTURES", data);
					return true;
				})
				.catch((error) => {
					if (error.response) {
						let message =
							error.response.data.message ||
							error.response.data.detail[0].msg;
						message == "Token expired"
							? commit("loginStore/SET_ACCESS_TOKEN", null, {
									root: true,
							  })
							: message
							? commit("SET_ERROR", message)
							: commit("SET_ERROR", "Algo salió mal");
					} else {
						console.log(error);
						commit("SET_ERROR", error);
					}
				});
			return getCulturesRes;
		},
	},
};
